@if (importType() !== 'projects') {
  <div class="row mb-3">
    <div class="col-4">
      <label class="form-label">Lots</label>
      <generic-dropdown
        class="w-100"
        [items]="lots()"
        [allowSearch]="true"
        [clearable]="true"
        placeholder="Select Lot"
        (valueChange)="onLotSelected($event)"
      />
    </div>
  </div>
}

<div class="overflow-y-auto">
  <div class="table-outer table-theme table-deposits">
    <div class="table-responsive h-100 table-critical-dates">
      <p-table [value]="_depositService.deposits()">
        <ng-template #header>
          <tr>
            <th colspan="4" class="bg-gray-300 text-center">Deposit Details</th>
          </tr>
          <tr>
            <th>Type</th>
            <!-- <th>Milestone</th> -->
            <th>Due Date</th>
            <th>Amount</th>
          </tr>
        </ng-template>
        <ng-template #body let-deposit let-rowIndex="rowIndex">
          <tr class="tr-1st-tentative">
            <td>
              <span>{{ getDepositTypeName(deposit?.depositType?.id) }}</span>
            </td>
            <!-- <td>
              <generic-dropdown
                [items]="tasks()"
                [clearable]="true"
                [required]="true"
                [placeholder]="'Select Milestone'"
                [(ngModel)]="deposit.taskId"
                (ngModelChange)="onTaskChange(rowIndex, $event.toString())"
              ></generic-dropdown>
            </td> -->
            <td>
              <p-datePicker
                appendTo="body"
                [showIcon]="true"
                dateFormat="mm/dd/yy"
                [placeholder]="'Due Date'"
                styleClass="w-100"
                [(ngModel)]="deposit.depositDueDate"
                (ngModelChange)="onDateChange(rowIndex, $event)"
                [disabled]="!canWriteDeals()"
              ></p-datePicker>
            </td>
            <td style="min-width: 200px">
              <currency-input-field
                [placeholder]="'Amount'"
                [requiredLabel]="true"
                [(ngModel)]="deposit.depositAmount"
                (ngModelChange)="onAmountChange(rowIndex, $event)"
                [disabled]="!canWriteDeals()"
              ></currency-input-field>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
